import timeZones from './store-time-zones';

export const storeLocalTime = (storeNumber) => {
  let storeTimezones = Object.keys(timeZones);
  const zoneStr = storeTimezones.find((store) => store === storeNumber);
  if (zoneStr) {
    const currentTime = (new Date().toLocaleString('en-US', { timeZone: timeZones[zoneStr] }));
    return new Date(currentTime);
  }
  return new Date();
};